import React, { ReactElement, ReactNode } from 'react';
import styles from './filterElementWrap.module.css';

const FilterElementWrap = ({ children }: { children: ReactNode }): ReactElement => {
  return <div className={styles.root}>{children}</div>;
};

export default FilterElementWrap;
